import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import styled from "styled-components";
import SnackbarContents from "./SnackbarContents";
import SnackbarText from "./SnackbarText";
import CloseSnackbarButton from "./CloseSnackbarButton";
import InfoIcon from "@material-ui/icons/Info";

const WarningSnackbar = styled<any>(Snackbar)<any>`
	div {
		background-color: ${props => props.theme.colors.warning};
		text-align: left;
	}
`;

export default ({ onClickClose, ...props }) => (
	<WarningSnackbar
		{...props}
		message={
			<SnackbarContents>
				<InfoIcon />
				<SnackbarText>{props.message}</SnackbarText>
			</SnackbarContents>
		}
		action={[<CloseSnackbarButton key="close-button" onClick={onClickClose} />]}
	/>
);
